import { useCallback } from 'react';
import { supabase } from '../lib/supabase';

export function useFollowUps() {
  const getFollowUps = useCallback(async ({ userId, pendingOnly = false }) => {
    let query = supabase
      .from('follow_ups')
      .select('*')
      .eq('user_id', userId)
      .order('remind_at', { ascending: true });
    if (pendingOnly) query = query.eq('completed', false);
    const { data, error } = await query;
    if (error) throw error;
    return data || [];
  }, []);

  const createFollowUp = useCallback(async (followUp) => {
    const { data, error } = await supabase.from('follow_ups').insert(followUp).select().single();
    if (error) throw error;
    return data;
  }, []);

  const completeFollowUp = useCallback(async (id) => {
    const { data, error } = await supabase
      .from('follow_ups')
      .update({ completed: true })
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  }, []);

  const deleteFollowUp = useCallback(async (id) => {
    const { error } = await supabase.from('follow_ups').delete().eq('id', id);
    if (error) throw error;
  }, []);

  return { getFollowUps, createFollowUp, completeFollowUp, deleteFollowUp };
}
